import React from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSearch from "../components/HeroSearch";
import ListingsBrowser from "../components/ListingsBrowser";
import Seo from "../components/Seo";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";

  return (
    <div className="min-h-screen flex flex-col">
      <Seo title={`Search${q ? `: ${q}` : ""} — The Pataudi`} description="Search property, vehicle and service listings on The Pataudi." />
      <Header />
      <main className="flex-1">
        <div className="bg-primary">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
            <HeroSearch initial={{ q, category: params.get("category") || "", city: params.get("city") || "", area: params.get("area") || "" }} />
          </div>
        </div>
        <ListingsBrowser key={params.toString()} showQuery />
      </main>
      <Footer />
    </div>
  );
}
